/**
 * AuditoriaTransfolha
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {AuditoriaTransfolhaCollection} from '@/model/collection/AuditoriaTransfolhaCollection'

/* TODO: review generated class */
export class AuditoriaTransfolha extends Resource {
  idAuditoria: number | null = null
  lote: string | null = null
  json: string | null = null
  dataCriacao: string | null = null
  reprocessar: boolean | null = null

  get $id() {
    /* TODO: define the ID */
    return 0
  }
  set $id(val) {
    /* TODO: define the ID */
  }

  /**
   * Gets a instance of a given ID of AuditoriaTransfolha
   */
  async getAuditoriaTransfolha(id: number) {
    return await Request.get(`/admin/auditoria-transfolha/${id}`)
      .name('getAuditoriaTransfolha')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of AuditoriaTransfolha
   */
  static async listAuditoriaTransfolha(params: any) {
    return await Request.get(`/admin/auditoria-transfolha`, {params})
      .name('listAuditoriaTransfolha')
      .as(AuditoriaTransfolhaCollection)
      .getData()
  }

  /**
   * Persists a new instance of AuditoriaTransfolha. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistAuditoriaTransfolha() {
    return await Request.post(`/admin/auditoria-transfolha`, this)
      .name('persistAuditoriaTransfolha')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of AuditoriaTransfolha to use it in a CSV file
   */
  static async listCsvAuditoriaTransfolha(params: any) {
    return await Request.get(`/admin/auditoria-transfolha/csv`, {params})
      .name('listCsvAuditoriaTransfolha')
      .as(AuditoriaTransfolhaCollection)
      .getData()
  }
}
